/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'link.scss' instead.
import { css } from 'lit';
export default css `@media (min-width:768px){:host a{border-bottom:0!important;color:inherit!important;cursor:default!important;font-weight:inherit!important;padding-bottom:0!important;pointer-events:none}:host:focus{color:var(--cipublic-color-white)!important}}`;
//# sourceMappingURL=link.scss.js.map